export default "__VITE_ASSET__CC5my$E$__"